/**
 * Discriminated union for use-case outcomes that have meaningful failure cases.
 *
 * Use cases return `Result<T, E>` for *expected* failure modes (invalid
 * credentials, validation rejection, etc.) so callers must handle every
 * variant exhaustively at the type level.
 *
 * **Don't** wrap unexpected/exceptional failures (network down, programming
 * bugs) in `Result` — let those throw. Use cases catch infrastructure throws
 * at the boundary and either translate them to a known error variant or let
 * them propagate as a generic `"unknown"` variant.
 */
export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

export const ok = <T, E = never>(value: T): Result<T, E> => ({ ok: true, value });
export const err = <E, T = never>(error: E): Result<T, E> => ({ ok: false, error });
